export enum TRIGGER_ACTION_TYPE {
  EMAIL = 'EMAIL',
  PUBSUB = 'PUBSUB',
  NOTIFICATION = 'NOTIFICATION',
  UNKNOWN = '',
}
